import { render, staticRenderFns } from "./TherapyPasswordReset.vue?vue&type=template&id=3a77ffee"
import script from "./TherapyPasswordReset.vue?vue&type=script&lang=js"
export * from "./TherapyPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./TherapyPasswordReset.vue?vue&type=style&index=0&id=3a77ffee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports